const DODGER_BLUE_COLOR_NAME = "dodger-blue";
const SPACE_BLUE_COLOR_NAME = "space-blue";
const SPACE_BLUE_GRADIANT_COLOR_NAME = "space-blue-gradiant";
const SPACE_BLUE_VIDEO_ONLY_COLOR_NAME = "space-blue-video-only";
const SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME = "space-blue-video-only-desktop";
const WHITE_COLOR_NAME = "white";
const IRIS_COLOR_NAME = "iris";
const BLUE_COLOR_NAME = "blue";
const RIVERSTONE_COLOR_NAME = "riverstone";
const PROJECTS_ORANGE_COLOR_NAME = "projects-orange";
const CRM_GREEN_COLOR_NAME = "crm-green";
const MARKETING_RED_COLOR_NAME = "marketing-red";
const DEV_GREEN_COLOR_NAME = "dev-green";
const WORK_OS_IRIS_COLOR_NAME = "workos-iris";
const LIGHT_PROJECTS_ORANGE_COLOR_NAME = "projects-orange-light";
const LIGHT_CRM_GREEN_COLOR_NAME = "crm-green-light";
const LIGHT_MARKETING_RED_COLOR_NAME = "marketing-red-light";
const LIGHT_DEV_GREEN_COLOR_NAME = "dev-green-light";
const LIGHT_WORK_OS_IRIS_COLOR_NAME = "workos-iris-light";
const DARK_PROJECTS_ORANGE_COLOR_NAME = "projects-orange-dark";
const DARK_CRM_GREEN_COLOR_NAME = "crm-green-dark";
const DARK_MARKETING_RED_COLOR_NAME = "marketing-red-dark";
const DARK_DEV_GREEN_COLOR_NAME = "dev-green-dark";
const DARK_WORK_OS_IRIS_COLOR_NAME = "workos-iris-dark";
const BACKGROUND_GRAY_COLOR_NAME = "background-gray";
const BLACK_COLOR_NAME = "black";
const GRADIANT_WORKOS_IRIS_COLOR_NAME = "gradiant-workos-iris";
const GRADIANT_WORKOS_IRIS_HOVER_COLOR_NAME = "gradiant-workos-iris-hover";
const GRADIANT_BRAND_GRAY_COLOR_NAME = "gradiant-brand-gray";
const WORKFORMS_RED_COLOR_NAME = "workforms-red";
const LIGHT_BLUE_VIDEO_BACKGROUND_COLOR_NAME = "light-blue-video-background";
const PEACH_COLOR_NAME = "peach";
const TEAL_COLOR_NAME = "teal";

const PROJECTS_BLUE_COLOR_NAME = "projects-blue"; // DEPRECATED
const LIGHT_PROJECTS_BLUE_COLOR_NAME = "projects-blue-light"; // DEPRECATED
const DARK_PROJECTS_BLUE_COLOR_NAME = "projects-blue-dark"; // DEPRECATED
const DEV_ORANGE_COLOR_NAME = "dev-orange"; // DEPRECATED
const LIGHT_DEV_ORANGE_COLOR_NAME = "dev-orange-light"; // DEPRECATED
const DARK_DEV_ORANGE_COLOR_NAME = "dev-orange-dark"; // DEPRECATED

export {
  DODGER_BLUE_COLOR_NAME,
  SPACE_BLUE_COLOR_NAME,
  WHITE_COLOR_NAME,
  IRIS_COLOR_NAME,
  BLUE_COLOR_NAME,
  RIVERSTONE_COLOR_NAME,
  PROJECTS_BLUE_COLOR_NAME,
  PROJECTS_ORANGE_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME,
  DEV_GREEN_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  LIGHT_PROJECTS_BLUE_COLOR_NAME,
  LIGHT_PROJECTS_ORANGE_COLOR_NAME,
  LIGHT_MARKETING_RED_COLOR_NAME,
  LIGHT_CRM_GREEN_COLOR_NAME,
  LIGHT_DEV_ORANGE_COLOR_NAME,
  LIGHT_DEV_GREEN_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME,
  DARK_PROJECTS_BLUE_COLOR_NAME,
  DARK_PROJECTS_ORANGE_COLOR_NAME,
  DARK_MARKETING_RED_COLOR_NAME,
  DARK_CRM_GREEN_COLOR_NAME,
  DARK_DEV_ORANGE_COLOR_NAME,
  DARK_DEV_GREEN_COLOR_NAME,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  BACKGROUND_GRAY_COLOR_NAME,
  BLACK_COLOR_NAME,
  SPACE_BLUE_GRADIANT_COLOR_NAME,
  GRADIANT_WORKOS_IRIS_COLOR_NAME,
  GRADIANT_WORKOS_IRIS_HOVER_COLOR_NAME,
  GRADIANT_BRAND_GRAY_COLOR_NAME,
  WORKFORMS_RED_COLOR_NAME,
  SPACE_BLUE_VIDEO_ONLY_COLOR_NAME,
  SPACE_BLUE_VIDEO_ONLY_DESKTOP_COLOR_NAME,
  LIGHT_BLUE_VIDEO_BACKGROUND_COLOR_NAME,
  PEACH_COLOR_NAME,
  TEAL_COLOR_NAME
};
